export default __webpack_public_path__ + "static/media/DSC_0563.8cb2f413.webp";